<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0px;">A. J. King is 57 years old and an artist, coach and author living in Scotland. In 2009 she experienced a series of unfortunate events that would test the strongest person. She survived and learned lessons that would set her up for a dramatic turnaround. Making her story into a work of fiction was the only way she could tell it.</p><br/>
<p style="text-indent:0px;">This is the first of two books that will share her story of losing everything only to eventually find her holy grail.</p><br/>
<p style="text-indent:0px;">Her artwork depicts women and their power and her website showcases all of her creative works and her powerful new signature coaching programme ‘The Creative Business Academy.’</p><br/>
<p style="text-indent:0px;">Find her at www.mandynicholson.co.uk</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1e7bee79